/* Approved per-preview constant gain. Cassette and drum one-shots are never routed here. */
(function(){
if(window.REWIND_PREVIEW_GAIN)return;
const gains={
  "rewind-audio-analog-beautiful-layers.mp3": 0.8,
  "rewind-audio-analog-funk-lead.mp3": -4.5,
  "rewind-audio-analog-juno-bass-combined.mp3": -2.2,
  "rewind-audio-analog-sine-lead.mp3": -3,
  "rewind-audio-analog-smooth-tines.mp3": 2,
  "rewind-audio-analog-soft-sine-pad.mp3": -1.1,
  "rewind-audio-analog-warm-chorus-bell.mp3": -0.8,
  "rewind-audio-hook-baby-dry.mp3": -0.7,
  "rewind-audio-hook-baby-pitched.mp3": -0.8,
  "rewind-audio-hook-baby-wet.mp3": -0.7,
  "rewind-audio-hook-believe-it-dry.mp3": 0.8,
  "rewind-audio-hook-believe-it-pitched.mp3": 0.9,
  "rewind-audio-hook-believe-it-wet.mp3": 1,
  "rewind-audio-hook-meet-up-dry.mp3": 1.9,
  "rewind-audio-hook-meet-up-pitched.mp3": 1.3,
  "rewind-audio-hook-meet-up-wet.mp3": 1.5,
  "rewind-audio-hook-still-love-you-dry.mp3": 1.8,
  "rewind-audio-hook-still-love-you-pitched.mp3": 1.5,
  "rewind-audio-hook-still-love-you-wet.mp3": 1.6,
  "rewind-audio-loop-17-128bpm.mp3": 1.7,
  "rewind-audio-loop-19-130bpm.mp3": 0.3,
  "rewind-audio-melodic-1.mp3": 0.7,
  "rewind-audio-melodic-11.mp3": 2.2,
  "rewind-audio-melodic-21.mp3": -6,
  "rewind-audio-melodic-4.mp3": 3,
  "rewind-audio-melodic-59.mp3": -0.4,
  "rewind-audio-melodic-66.mp3": -2.4,
  "rewind-audio-melodic-76.mp3": -0.2,
  "rewind-audio-melodic-77.mp3": 0.4,
  "rewind-midi-come-back.mp3": 0.2,
  "rewind-midi-like-water.mp3": 2.3,
  "rewind-midi-royalty.mp3": -2.4,
  "rewind-midi-tears.mp3": -0.2,
  "rewind-midi-whispers.mp3": -2.7,
  "rewind-audio-phrase-109-dry.mp3": -2.2,
  "rewind-audio-phrase-109-pitched.mp3": 0.1,
  "rewind-audio-phrase-109-wet.mp3": -3,
  "rewind-audio-phrase-127-dry.mp3": -1.8,
  "rewind-audio-phrase-127-pitched.mp3": -2.5,
  "rewind-audio-phrase-127-wet.mp3": -1.2,
  "rewind-audio-phrase-42-dry.mp3": -2.1,
  "rewind-audio-phrase-42-pitched.mp3": -1.7,
  "rewind-audio-phrase-42-wet.mp3": -1.6,
  "rewind-audio-phrase-60-dry.mp3": 3,
  "rewind-audio-phrase-60-pitched.mp3": 3,
  "rewind-audio-phrase-60-wet.mp3": 3,
  "rewind-audio-phrase-62-dry.mp3": 0.2,
  "rewind-audio-phrase-62-pitched.mp3": 1,
  "rewind-audio-phrase-62-wet.mp3": -2.1,
  "rewind-audio-phrase-89-dry.mp3": 0.9,
  "rewind-audio-phrase-89-pitched.mp3": 1,
  "rewind-audio-phrase-89-wet.mp3": 1.1
};
const entries=new WeakMap();let context;
function approved(media,source){
 const host=media.closest('rewind-vocal-player,rewind-drum-machine,rewind-midi-player,rewind-analog-player,rewind-melodic-player');
 if(!host||media.closest('rewind-cassette')||media.dataset.rewindManaged==='pad')return null;
 try{const url=new URL(source,location.href),name=decodeURIComponent(url.pathname.split('/').pop());
 if(!(url.origin===location.origin||url.hostname==='cdn.shopify.com'||url.hostname.endsWith('.myshopify.com')))return null;
 return Object.hasOwn(gains,name)?gains[name]:null;}catch{return null}
}
function configure(media,source){const db=approved(media,source);if(db!==null)media.crossOrigin='anonymous';else if(!entries.has(media))media.removeAttribute('crossorigin');return db}
function prepare(media,source){
 const db=configure(media,source),existing=entries.get(media);
 if(db===null&&!existing)return;
 // Only construct/resume the context on a user-initiated playback call.
 const AudioContext=window.AudioContext||window.webkitAudioContext;if(!AudioContext)return;
 try{context ||= new AudioContext();const resume=context.state==='running'?Promise.resolve():context.resume();
 Promise.resolve(resume).then(()=>{
  if(context.state!=='running')return;
  // Source may have changed while resuming; use the latest source's gain.
  const current=approved(media,media.getAttribute('src')||source);let entry=entries.get(media);
  if(current===null&&!entry)return;
  if(!entry){const input=context.createMediaElementSource(media),gain=context.createGain();gain.gain.value=Math.pow(10,(current||0)/20);input.connect(gain);gain.connect(context.destination);entry={input,gain};entries.set(media,entry)}
  entry.gain.gain.setValueAtTime(Math.pow(10,(current||0)/20),context.currentTime);
 }).catch(()=>{/* Keep native playback if audio processing cannot initialise. */});
 }catch{/* AudioContext unavailable: retain native playback. */}
}
window.REWIND_PREVIEW_GAIN={configure,prepare,wrap(session){const play=session.play.bind(session);session.play=(source,restart=false)=>{if(source){const media=session.getMedia();prepare(media,source)}return play(source,restart)};return session}};
})();
